module.exports = __webpack_public_path__ + "img/moe_logo_kg.b0103ef5.svg";